import { render, staticRenderFns } from "./SideTagsAddPlan.vue?vue&type=template&id=0d681f7d&scoped=true&"
import script from "./SideTagsAddPlan.vue?vue&type=script&lang=js&"
export * from "./SideTagsAddPlan.vue?vue&type=script&lang=js&"
import style0 from "./SideTagsAddPlan.vue?vue&type=style&index=0&id=0d681f7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d681f7d",
  null
  
)

export default component.exports